module.exports = __webpack_public_path__ + "e605c00469bc50680083281120a943af.svg";